import { formatNumber } from '@/shared/utils/number'

// searchFiles/searchItems use Elasticsearch's default counting threshold and
// return only hits.total.value, discarding its eq/gte relation. At this boundary
// the total may be a lower bound; this does not limit cursor pagination.
const SEARCH_TOTAL_THRESHOLD = 10_000

export const formatSearchTotal = (total: number) =>
  `${formatNumber(total)}${total === SEARCH_TOTAL_THRESHOLD ? '+' : ''}`
